import script from "./ux-settings-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./ux-settings-editor.vue?vue&type=script&setup=true&lang=js"

import "./ux-settings-editor.vue?vue&type=style&index=0&id=59dbc38c&lang=scss"

const __exports__ = script;

export default __exports__